import { createSlice } from "@reduxjs/toolkit";

import {
  getUserDetails,
  getDefaultConfig,
  getUsersDetails,
  updateUser,
} from "../../apis";

export const userDashboardPlatform = createSlice({
  name: "userDashboard",
  initialState: {
    loading: false,
    error: "",
    getUserDashboardDetails: {},
    getDefaultConfigData: {},
    getUsersDetailsData: {},
    updateUserSuccess: false,
    country: "",
  },
  reducers: {
    clear: (state, action) => {
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserDetails.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getUserDetails.fulfilled, (state, action) => {
      state.loading = true;
      state.error = "";
      state.getUserDashboardDetails = action.payload.data;
    });
    builder.addCase(getUserDetails.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
    builder.addCase(getDefaultConfig.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getDefaultConfig.fulfilled, (state, action) => {
      state.loading = true;
      state.error = "";
      state.getDefaultConfigData = action.payload.data;
      state.country = action.payload.data?.teams || "";
    });
    builder.addCase(getDefaultConfig.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
    builder.addCase(getUsersDetails.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getUsersDetails.fulfilled, (state, action) => {
      state.loading = true;
      state.error = "";
      state.getUsersDetailsData = action.payload.data;
    });
    builder.addCase(getUsersDetails.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
    builder.addCase(updateUser.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.loading = false;
      state.updateUserSuccess = true;
    });
    builder.addCase(updateUser.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
  },
});

export const { clear } = userDashboardPlatform.actions;

export default userDashboardPlatform.reducer;
